// controllers/loader_controller.js
import { Controller } from 'stimulus'

export default class extends Controller {
  toggle(event) {
    const attributeToToggle = this.element.dataset.attributeToToggle

    const valuesToToggle = this.element.dataset.valuesToToggle.split(' ')

    if (this.element.getAttribute(attributeToToggle) === valuesToToggle[0]) {
      this.element.setAttribute(attributeToToggle, valuesToToggle[1])
    } else {
      this.element.setAttribute(attributeToToggle, valuesToToggle[0])
    }
  }

  setEnabled(event) {
    this.element.removeAttribute('disabled')
  }

  setDisabled(event) {
    this.element.setAttribute('disabled', 'disabled')
  }

  setHidden(event) {
    this.element.setAttribute('hidden', 'hidden')
    this.element.classList.add('hidden')
  }

  setVisible(event) {
    this.element.removeAttribute('hidden')
    this.element.classList.remove('hidden')
  }
}
